import { InstantSearch } from 'react-instantsearch';
import algoliasearch, { type SearchClient } from 'algoliasearch/lite';

import WhatsNewSearchForm from './whats-new-search-form';

import type { IWhatsNewTimeline } from './types';

const GATSBY_ALGOLIA_API_KEY = process.env.GATSBY_ALGOLIA_API_KEY; 
const GATSBY_ALGOLIA_APP_ID = process.env.GATSBY_ALGOLIA_APP_ID; 

// instantiate the Algolia search client
export const searchClient: SearchClient = algoliasearch(`${GATSBY_ALGOLIA_APP_ID}`, `${GATSBY_ALGOLIA_API_KEY}`);


const WhatsNewTimeline = (props: IWhatsNewTimeline) => (
  <InstantSearch searchClient={searchClient} insights>
    <WhatsNewSearchForm {...props}/>
  </InstantSearch>
);

export default WhatsNewTimeline;
